// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ant-upload-select-picture-card i[data-v-8554ca42] {\n    font-size: 32px;\n    color: #999;\n}\n.ant-upload-select-picture-card .ant-upload-text[data-v-8554ca42] {\n    margin-top: 8px;\n    color: #666;\n}\n[data-v-8554ca42] .vxe-toolbar {\n  padding-left: 0\n}\n", ""]);
// Exports
module.exports = exports;
